import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreDescription$1 from './StoreDescription.js';

const StoreDescriptionContainer = (_param)=>{
    var { storeName , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeName",
        "description"
    ]);
    const { getFormattedLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getFormattedLabel('stores.page.details.description.title', {
                labelData: {
                    store: storeName
                }
            })
        })
    , [
        storeName,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreDescription$1, swcHelpers.extends({
        labels: labels,
        description: description
    }, rest));
};
var StoreDescription = StoreDescriptionContainer;

export { StoreDescription as default };
//# sourceMappingURL=StoreDescriptionContainer.js.map
